import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import SchemesQuery from "../CommonForm/indexRejPage";
import { getExistedSchemesAplication, queryApplication } from "../../../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { formFieldDataP1, formFieldDataP2, formFieldDataP3 } from "../../../../../../core/data/json/DistrictAPMC";
import { useLocation } from "react-router";
import { ToastContainer } from "react-toastify";

const SeniorAuthorityTable = () => {
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const [existData, setExistData] = useState<any | null>(null);
  const [queries, setQueries] = useState([]);
  const [unverifiedFields, setUnverifiedFields] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const roleIdentifier = userDetail.Role.Role_Identifier;
const [resubmittedFields, setResubmittedFields] = useState({
  annexureOne: {},
  annexureTwo: {},
  annexureThree: {}
});

// ------------------------------------Validations
  const [validationErrors, setValidationErrors] = useState<{[key: string]: string}>({});
  const [isValidating, setIsValidating] = useState(false);


const validateResubmittedFields = (): boolean => {
  const errors: {[key: string]: string} = {};
  let hasErrors = false;

  // Only validate fields that are present in the queries (i.e., actually need resubmission)
  queries.forEach(query => {
    const annexureType = query.annexureType;
    const fieldName = query.fieldName;
    const errorKey = `${annexureType}_${fieldName}`;
    const fieldData = resubmittedFields[annexureType]?.[fieldName];

    if (!fieldData || fieldData.length === 0) {
      errors[errorKey] = `${fieldName} is required for resubmission`;
      hasErrors = true;
    } 
    
  });

  setValidationErrors(errors);
  return !hasErrors;
};

// Function to clear specific validation error
const clearValidationError = (errorKey: string) => {
  setValidationErrors(prev => {
    const newErrors = { ...prev };
    delete newErrors[errorKey];
    return newErrors;
  });
};

  
  // Function to find field data from form field arrays
  const findFieldData = (fieldName) => {
    const allFormData = [...(formFieldDataP1 || []), ...(formFieldDataP2 || []), ...(formFieldDataP3 || [])];
    return allFormData.find(field => 
      field?.response && Array.isArray(field.response) && field.response.some(resp => resp?.fieldName === fieldName)
    );
  };

  const location = useLocation();

  // Function to extract unverified fields
  const extractUnverifiedFields = (apiData) => {
    const unverified = [];
    
    const annexures = [
      { data: apiData?.annexureOne, name: "annexureOne" },
      { data: apiData?.annexureTwo, name: "annexureTwo" },
      { data: apiData?.annexureThree, name: "annexureThree" }
    ];

    annexures.forEach(({ data: annexureData }) => {
      if (annexureData) {
        Object.keys(annexureData).forEach(fieldName => {
          const fieldData = annexureData[fieldName];
          if(fieldName!=="estimateProjectCost")
       {   if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
            const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
            
            if (lastTransaction?.isVerified === false) {
              unverified.push(fieldName);
            }
          }}
        });
      }
    });

    return unverified;
  };

  // Function to generate queries from API data
  const generateQueries = (apiData) => {
    const generatedQueries = [];
    let keyCounter = 1;

    const annexures = [
      { data: apiData?.annexureOne, name: "Table 1", type: "annexureOne" },
      { data: apiData?.annexureTwo, name: "Table 2", type: "annexureTwo" },
      { data: apiData?.annexureThree, name: "Table 3", type: "annexureThree" }
    ];

    annexures.forEach(({ data: annexureData, name: annexureName, type: annexureType }) => {
      if (annexureData) {
        Object.keys(annexureData).forEach(fieldName => {
          const fieldData = annexureData[fieldName];
               if(fieldName!=="estimateProjectCost")
       {   if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
            const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];

            if (lastTransaction?.isVerified === false) {
              const formFieldData = findFieldData(fieldName);

              generatedQueries.push({
                key: keyCounter++,
                annexure: annexureName,
                annexureType: annexureType,
                fieldNumber: formFieldData?.fieldNo || formFieldData?.fieldVal,
                // comment: lastTransaction.comment || "No comment provided",
                districtComment: lastTransaction?.comment || lastTransaction.standardizedComment || "No district comment provided",
                status: "Pending",
                checked: false,
                fieldName: fieldName,
                transactionData: lastTransaction
              });
            }
          }}
        });
      }
    });

    return generatedQueries;
  };

  const columns = [
    {
      title: "Annexure",
      dataIndex: "annexure",
      width: 150,
      render: (text) => <span className="badge bg-light text-dark border">{text}</span>
    },
    {
      title: "Field Number",
      dataIndex: "fieldNumber",
      ellipsis: true,
    },
    {
      title: "Comment",
      dataIndex: "districtComment",
      render: (text: string) => (
        <div style={{ maxWidth: '300px', wordWrap: 'break-word', backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px' }}>
          {text}
        </div>
      )
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (status) => (
        <span
          style={{
            color: status === "Resolved" ? "#0d6efd" : "red",
            fontWeight: 500
          }}
        >
          {status}
        </span>
      )
    }
  ];


const prepareRejectedFieldNames = () => {
  return queries
    .filter(query => 
      resubmittedFields[query.annexureType] &&
      resubmittedFields[query.annexureType][query.fieldName]
    )
    .map(query => ({
      annexureType: query.annexureType,
      key: query.fieldName,
      // comment: query.districtComment || query.transactionData?.districtComment || query.transactionData?.standardizedComment || ""
    }));
};



  // Function to prepare resubmitted fields for API (from existData - getExistedSchemesAplication)
  const prepareResubmittedFields = () => {
    const resubmittedField = {
      annexureOne: {},
      annexureTwo: {},
      annexureThree: {}
    };

    // For each query, if there's a corresponding resubmitted value,
    // ensure it's sent as an object with a `data` key (e.g. { data: [ ... ] }).
    queries.forEach(query => {
      const annexureType = query.annexureType;
      const fieldName = query.fieldName;
      const value = resubmittedFields?.[annexureType]?.[fieldName];

      if (value !== undefined) {
        // If the value already looks like { data: ... }, keep it as-is.
        if (value && typeof value === 'object' && !Array.isArray(value) && Object.prototype.hasOwnProperty.call(value, 'data')) {
          resubmittedField[annexureType][fieldName] = value;
        } else {
          // Otherwise wrap the raw value (often an array of objects) under `data`.
          resubmittedField[annexureType][fieldName] = { data: value };
        }
      }
    });

    // Remove empty annexures
    Object.keys(resubmittedField).forEach(key => {
      if (Object.keys(resubmittedField[key]).length === 0) {
        delete resubmittedField[key];
      }
    });

    return resubmittedField;
  };

  // Function to handle submission
  const handleSubmitAgain = async (status, appStatusLevel) => {
    try {
      if (queries.length === 0) {
        message.warning("No queries available to submit.");
        return;
      }

       setIsValidating(true);
      const isValid = validateResubmittedFields();

      if (!isValid) {
        message.error({
          content: (
            <div>
              <div>Please fill all required fields for unverified data before submitting.</div>
              <div>સબમિટ કરતા પહેલા કૃપા કરીને બધા જરૂરી ફીલ્ડ્સ ભરો.</div>
            </div>
          ),
          duration: 5,
        });
        setIsValidating(false);
        return;
      }

      setIsSubmitting(true);

      // Prepare the payload combining data from both APIs
      // Fields from getExistedSchemesAplication: status, appStatusLevel, annexure data
      // Fields from queryApplication: applicationId, schemeId (from location state)
      const payload = {
        applicationId: String(applicationId), // From location state
        status: status, // From getExistedSchemesAplication
        appStatusLevel: appStatusLevel, // From getExistedSchemesAplication
        applicationType: "scheme", // Required field
        schemeId: id, // From location state
        rejectedFieldName: prepareRejectedFieldNames(), // Generated from getExistedSchemesAplication data
        reSubmittedFields: prepareResubmittedFields() // From getExistedSchemesAplication annexure data
      };

  

      // Call the queryApplication API with the combined payload
      const response = await queryApplication(payload, token);

      if (response?.success) {
        message.success("Application submitted successfully!");
        
        // Update status after successful submission
        setQueries(prev => prev.map(query => ({
          ...query,
          status: "Resolved"
        })));
        
        // Refresh the data to get updated information
        await getExistedApplication();
      } else {
        message.error("Failed to submit application. Please try again.");
      }

      setValidationErrors({});
      
    } catch (error) {
     
      message.error("An error occurred while submitting. Please try again.");
    } finally {
      setIsSubmitting(false);
      setIsValidating(false);
    }
  };

  const pendingCount = queries.filter((q) => q.status === "Pending").length;
  const resolvedCount = queries.filter((q) => q.status === "Resolved").length;
  const totalCount = queries.length;
  
  const [applicationId, setApplicationID] = useState(location?.state?.applicationId);
  const [id, setId] = useState(location?.state?.id);

  // Function to get existing application data
  const getExistedApplication = async () => {
    try {
    
      const response = await getExistedSchemesAplication(token, applicationId, id);
    

      if (response?.success) {
      
        setExistData(response?.data);
        
        // Generate queries and extract unverified fields from the API response
        const generatedQueries = generateQueries(response.data);
        const unverified = extractUnverifiedFields(response.data);
        
        setQueries(generatedQueries);
        setUnverifiedFields(unverified);
        
    
      }
    } catch (error) {
     
    }
  };

  useEffect(() => {
   
    if (token && applicationId && id) {
      getExistedApplication();
    }
  }, [token, applicationId, id]);

 return (
 <>   <div className="page-wrapper">
        <div>
            <h2 className="m-3">Application Id - {applicationId}</h2>
        </div>
       {( existData?.status==="resubmission"||existData?.status==="reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")&&<div className="m-3 mx-5 card p-3">
           <div className="d-flex justify-content-between">
                <div className="mb-2">
                    <h3 className="mb-1">
                    <i className="feather feather-message-square text-info"></i> Senior Authority Queries & Comments
                    </h3>
                    <p className="text-muted">Review district responses and submit</p>
                </div>

                <div className="mb-3">
                    <span className="text-danger">●</span> Pending: {pendingCount}
                    <span className="text-warning ms-3">●</span> Resolved Queries: {resolvedCount}
                    <span className="text-success ms-3">●</span> Total Queries: {totalCount}
                </div>
           </div>

        {queries.length > 0 ? (
          <Table
            columns={columns}
            dataSource={queries}
            pagination={{
              pageSize: 5,
              showTotal: (total, range) =>
                  `Showing ${range[0]} - ${range[1]} of ${total} entries`
            }}
            bordered
          />
        ) : (
          <div className="text-center p-4">
            <p className="text-muted">No unverified fields found.</p>
          </div>
        )}
        </div>}

        {/* This is the form table of District  */}
        <SchemesQuery 
          unverifiedFields={unverifiedFields}
          userRole={userDetail?.Role?.Role_Identifier}
          resubmittedFields={resubmittedFields}
          setResubmittedFields={setResubmittedFields}
          existData={existData}
          validationErrors={validationErrors} // Add this prop
          isValidating={isValidating} // Add this prop
          clearValidationError={clearValidationError} 
        />
        {/* <div className="d-flex justify-content-end mb-3 me-5">
          <button 
            className="btn btn-info"
            // onClick={handleSubmitAgain}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Again"}
          </button>
        </div> */}
        {existData && ["SEC"].includes(existData?.role)  &&
        <div className="d-flex justify-content-end mb-3 me-5">
          {existData.buttonName && existData?.buttonName.map((button) => (
            <button
              key={button.status}
              className={`btn ${
                button.status === "reject"
                  ? "btn-danger"
                  : button.status === "permanentReject" ? "btn-secondary" : "btn-success"
              } h-25 ms-3 w-25`}
              onClick={() =>
                handleSubmitAgain(
                  button.status,
                  button.appStatusLevel
                )
              }
              disabled={isSubmitting || isValidating}
            >
              {isSubmitting || isValidating ? "Processing..." : button.buttonLabel}
            </button>
            ))}
        </div>}

    </div>
     <ToastContainer position="top-right" autoClose={3000} />
     </>
  );
};

export default SeniorAuthorityTable;